import {type GuidType} from '../../../values/generic-type-definitions'

export interface ExtendedDataRequestReduxState {
    inventory: InventoryType | undefined
    isModalOpen: boolean
    currentLocations: GuidType[]
    data: DataRequest
    isProcessingSave: ProcessingStatus
    additionalRequirement: string | undefined
    isAdditionalRequirementExist: boolean
}

export interface DataRequest {
    location: GuidType | null
    title: string
    dateRange: string
    requirements: string[]
    purpose: string
    reference: string
}

export enum InventoryType {
    NETWORK = 'Networked devices',
    USB = 'USB devices',
    SOFTWARE = 'Software',
}

export enum ProcessingStatus {
    NOT_PROCESSING = 'NOT_PROCESSING',
    PROCESSING = 'PROCESSING',
    PROCESSED = 'PROCESSED',
    FAILED = 'FAILED',
}

export const DEFAULT_EXTENDED_DATA_REQUEST_STATE: ExtendedDataRequestReduxState = {
    inventory: undefined,
    isModalOpen: false,
    currentLocations: [],
    data: {} as DataRequest,
    isProcessingSave: ProcessingStatus.NOT_PROCESSING,
    additionalRequirement: undefined,
    isAdditionalRequirementExist: false,
}
